import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ApplicationFrame from './ApplicationFrame';
import ApplicationContext from './ApplicationContext';
import ApplicationHeader from './ApplicationHeader';
import ApplicationContent from './ApplicationContent';
import analyticsManager from './analyticsManager';
import sessionManager from './sessionManager';

class ApplicationRoot extends React.Component {
  constructor() {
    super();

    this.state = {
      // eslint-disable-next-line react/no-unused-state
      sessionManager,
    };
  }

  componentDidMount() {
    sessionManager.checkForExistingSession()
      .then(() => this.update());
    this.update();
  }

  update() {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ sessionManager });
    if (sessionManager.status.isAuthenticated && !this.hasIdentifiedUser) {
      analyticsManager.user(sessionManager.user);
      this.hasIdentifiedUser = true;
    }
  }

  render() {
    return (
      <div
        id="mysw-root"
        className="mysw-root"
      >
        <ApplicationContext.Provider value={this.state}>
          <Router>
            <ApplicationFrame>
              <ApplicationHeader />
              <ApplicationContent />
            </ApplicationFrame>
          </Router>
        </ApplicationContext.Provider>
      </div>
    );
  }
}

export default ApplicationRoot;
